<template>
    <div class="p-tabs">
        <nav class="p-nav" :class="navClasses" v-show="shownavs">
            <ul class="p-tab-list" @click="tablistclick">
                <li @click.stop="changeTab(Math.max(activeTab-1,0))" class="p-tab-prev">
                    <b-icon :class="{ 'p-arrow-inactive': activeTab === 0 }"
                        icon="chevron-left"
                        size="is-medium">
                    </b-icon>
                </li>
                <li 
                    v-for="(tabItem, index) in tabItems"
                    :key="index"
                    v-show="tabItem.visible"
                    :class="{ 'active': activeTab === index, 'disabled': tabItem.disabled }"            
                    class="p-tab-button"
                    @click="tabClick(index)"
                >
                        <template v-if="tabItem.$slots.header">
                            <p-slot-component
                                :component="tabItem"
                                name="header"
                                tag="span" />
                        </template>
                        <template v-else>
                            <b-icon
                                v-if="tabItem.icon"
                                :icon="tabItem.icon"
                                :pack="tabItem.iconPack"
                                :size="size"/>
                            <span>{{ tabItem.label }}</span>
                        </template>
                </li>
                <!--
                <li class="p-tab-button active">Tab Name 2</li>
                <li class="p-tab-button">Tab Name 3</li>
                -->
                <li @click.stop="changeTab(Math.min(activeTab+1,tabItems.length-1))" class="p-tab-next">
                    <b-icon :class="{ 'p-arrow-inactive': activeTab === tabItems.length-1}"
                        icon="chevron-right"
                        size="is-medium">
                    </b-icon>
                </li>
            </ul>
        </nav>
        <section class="p-tab-contents">
            <slot/>
        </section>
        <!--
        <section class="p-tab-contents">
            <div class="p-tab-content">
                One Content Here
            </div>
            <div class="p-tab-content">
                Two Content Here
            </div>
            <div class="p-tab-content">
                Three Content Here
            </div>
        </section>
        -->
    </div>
</template>

<style>

    .p-tabs { padding: 0; }
    .p-tab-contents { position: relative; overflow: visible; display: flex; flex-direction: column;}
    .p-tabs .p-tab-contents .tab-item {
        flex-shrink: 0;
        flex-basis: auto;
    }
    .p-nav { position: relative; }
    .p-tab-list { background:#fff; display: flex; align-items: center; list-style: none;margin:0; padding:0; }
    .p-tab-button, .p-tab-prev, .p-tab-next { cursor: pointer;  }
    .p-tab-button { 
        line-height: 2rem; display: none; flex-grow: 1; align-items:center; justify-content: center;
        text-align: center; border-left: 1px solid #ddd; border-right: 1px solid #ddd; 
        white-space: nowrap;
    }
    .p-tab-button.active { display: flex; position: relative; }
    .p-tab-select > .p-tab-button.active { 
        background: #e0e0e0;
        }

    .p-tab-prev, .p-tab-next { 
        display:flex; align-items: center; justify-content:center;  
        height: 3.25rem; width: 3.25rem; 
    }
    .p-tab-prev {  }
    .p-tab-next {  }
    .p-tab-select { 
        flex-direction: column; align-items: stretch; position: absolute; 
        top: 0; left: 0; right: 0; 
        z-index: 20;
    }
    .p-tab-select > .p-tab-next, .p-tab-select > .p-tab-prev { display: none; }
    .p-tab-select > .p-tab-button { 
            border-bottom: 0px solid #ddd ;
            display: flex; 
            align-items: center;
            justify-content: center;
            min-height: 3.25rem;
    }
    .p-tab-select > .p-tab-button { border-bottom: 1px solid #ebebeb; }
    .p-arrow-inactive { color: #ebebeb; }
    .p-tab-contents { margin-top: 1rem; position: relative; }
    .p-tab-contents .slide-next-leave-to, .p-tab-contents .slide-prev-leave-to { top: 0; }

    @media (min-width: 768px) {
        .p-tab-list { background: none; border-bottom: 1px solid #ddd }
        .p-tab-list.p-tab-select, .p-tab-list { flex-direction: row; align-items: center; }
        .p-tab-button { 
            flex-grow: 0; margin-right: 0.25rem; padding: 0 1rem; 
            border-bottom: 1px solid transparent; border-left: none; border-right: none;
            margin-bottom: -1px;  
            min-height: 3.25rem;
            display: flex;
        }
        .p-tab-select { position: static; }
        .p-tab-select > .p-tab-button { 
            border-bottom: 1px solid transparent;
            }

        .p-tab-button.active, .p-tab-select .p-tab-button.active { border-bottom-color: #f90; background: none;  }
        .p-tab-prev, .p-tab-next { display: none; }
    }
</style>

<script>
import PSlotComponent from './SlotComponent.js'
export default {
        name: 'PTabs',
        components: {
            //[Icon.name]: Icon,
            [PSlotComponent.name]: PSlotComponent
        },
        props: {
            value: Number,
            expanded: Boolean,
            type: String,
            size: String,
            position: String,
            animated: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                activeTab: this.value || 0,
                tabItems: [],
                contentHeight: 0,
                // eslint-disable-next-line vue/no-reserved-keys
                _isTabs: true // Used internally by TabItem
            }
        },
        computed: {
            shownavs() { 
                return this.$store.getters.shownavs 
            },
            navClasses() {
                return [
                    this.type,
                    this.size,
                    this.position,
                    {
                        'is-fullwidth': this.expanded,
                        'is-toggle-rounded is-toggle': this.type === 'is-toggle-rounded'
                    }
                ]
            }
        },
        watch: {
            /**
             * When v-model is changed set the new active tab.
             */
            value(value) {
                this.changeTab(value)
            },
            /**
             * When tab-items are updated, set active one.
             */
            tabItems() {
                if (this.activeTab < this.tabItems.length) {
                    this.tabItems[this.activeTab].isActive = true
                }
            }
        },
        methods: {
            /**
             * Change the active tab and emit change event.
             */
            changeTab(newIndex) {
                if (this.activeTab === newIndex) return
                if (this.activeTab < this.tabItems.length) {
                    this.tabItems[this.activeTab].deactivate(this.activeTab, newIndex)
                }
                this.tabItems[newIndex].activate(this.activeTab, newIndex)
                this.activeTab = newIndex
                this.$emit('change', {index: newIndex, path: this.$route.path})
                
            },
            /**
             * Tab click listener, emit input event and change active tab.
             */
            tabClick(value) {
                this.$emit('input', value)
                this.changeTab(value)

            },
            tablistclick(ob) {
                ob.currentTarget.classList.toggle('p-tab-select')
            }
        },
        mounted() {
            if (this.activeTab < this.tabItems.length) {
                this.tabItems[this.activeTab].isActive = true
            }
        }
}
</script>

